<div class="panel-content bg-background h-full flex flex-col gap-3">
    <div class="py-6 px-8 field-intervention-header bg-white rounded-xl">
        <app-title
            [title]="'layer' | transloco: { COUNT: 2 }"
            (goToPreviousPage)="goToPreviousPage()" />
    </div>
    <div class="bg-white flex flex-col rounded-xl grow min-h-0 h-full p-6">
        @defer (when !isLoading()) {
            @if (layers().length) {
                <div class="overflow-x-auto grow">
                    <app-custom-table
                        class="h-full"
                        [columns]="tableColumns"
                        [isSelectable]="false"
                        [translateColumns]="true"
                        (sortEvent)="onSortChange($event)">
                        @for (layer of layers(); track layer.id) {
                            <tr (click)="fieldInterventionService.toggleFieldInterventionEntityDetailPanel(layer.id)">
                                @for (column of tableColumns; track column.key) {
                                    <td class="min-w-14">
                                        @switch (column.key) {
                                            @case ('name') {
                                                {{ layer.name }}
                                            }
                                            @case (NUMBER_OF_ENTITIES) {
                                                {{ layer.entitiesCount }}
                                            }
                                            @case ('depositFolder.name') {
                                                {{ layer.depositFolder.name }}
                                            }
                                            @case ('type') {
                                                {{ labelByLayerType[layer.type] | transloco: { COUNT: 1 } }}
                                            }
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </app-custom-table>
                </div>
                <div class="pt-2">
                    <app-pagination-footer-template
                        [canSearch]="false"
                        [paginationParameters]="paginationParameters"
                        [searchDisabled]="true"
                        [totalEntities]="paginationParameters.totalItems"
                        (onPageChange)="onPageChange($event)"
                        (paginator)="paginator.set($event)" />
                </div>
            } @else {
                <div class="h-full">
                    <app-no-data-to-display [iconSize]="'5x'" />
                </div>
            }
        } @placeholder (minimum 500ms) {
            <div class="min-h-45 min-w-full flex items-center justify-center">
                <app-loading />
            </div>
        }
    </div>
</div>
